import { DatePickerProps, KeyboardDatePicker } from "@material-ui/pickers";
import { ParsableDate } from "@material-ui/pickers/constants/prop-types";
import { MaterialUiPickersDate } from "@material-ui/pickers/typings/date";
import { FieldAttributes, useField, useFormikContext } from "formik";
import * as React from "react";
import { EventFormData } from "../../models/eventData";

interface CustomDatepickerProps {
  value?: ParsableDate;
  /* eslint-disable no-unused-vars */
  customChangeHandler?: (
    date: MaterialUiPickersDate | null,
    value?: string | null
  ) => void;
  /* eslint-enable no-unused-vars */
}

const CustomDatepicker: React.FC<
  FieldAttributes<unknown> & DatePickerProps & CustomDatepickerProps
> = ({ customChangeHandler, ...props }) => {
  const [field, meta] = useField<unknown>(props.name as string);
  const { setFieldValue } = useFormikContext<EventFormData>();
  const error = meta.error && meta.touched ? meta.error : ""; // get validation error text
  const hasExternalError = Boolean(props.error);
  const helperText = hasExternalError ? props.helperText : error;

  const handleDateChange = (
    date: MaterialUiPickersDate,
    value?: string | null | undefined
  ) => {
    if (customChangeHandler) {
      customChangeHandler(date, value);
    } else {
      setFieldValue(field.name, date);
    }
  };

  return (
    <KeyboardDatePicker
      {...field}
      {...props}
      InputProps={{ required: false }}
      inputVariant="filled"
      variant="inline"
      format="DD.MM.YYYY"
      helperText={helperText}
      error={hasExternalError || !!error}
      value={field.value || null}
      onChange={handleDateChange}
      KeyboardButtonProps={{
        "aria-label": `change ${field.name}`,
      }}
    />
  );
};

export default CustomDatepicker;
